import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=249305d6&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=249305d6&lang=less&scoped=true"
import style1 from "./Collection.vue?vue&type=style&index=1&id=249305d6&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249305d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249305d6')) {
      api.createRecord('249305d6', component.options)
    } else {
      api.reload('249305d6', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=249305d6&scoped=true", function () {
      api.rerender('249305d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Collection.vue"
export default component.exports